export default {
  methods: {
    jumpTo(path) {
        this.$router.push(path)
    },
    
  },
}